import React, { Component } from 'react'
import { Layout, Row, Col, Typography, Carousel } from 'antd'
import { Icon } from 'antd-mobile'
import { withTranslation } from 'react-i18next'
import InnerImageZoom from 'react-inner-image-zoom'

import FooterMenu from '../../components/Guest/Footer/Footer'

import './billing.css'

const { Content } = Layout
const { Text } = Typography

class BillingPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            dndSelected: false,
            comeBackSelected: false,
            confirmEnabled: false
        }
    }

    componentDidMount() {
    }

    aboutHotelBackClicked = () => this.props.history.push('/')

    render() {
        const history = this.props.history;

        return (
            <Layout className='layout-page'>
                <Content>
                    <Row>
                        <Col span={24} className='col-header'>
                            <Row>
                                <Col span={4} className='col-header-back' onClick={this.aboutHotelBackClicked}>
                                    <Icon type="left" size='lg' color='#FFF' />
                                </Col>
                                <Col span={16} className='col-header-text'>
                                    <Text className='text-header'>Guest Bill</Text>
                                </Col>
                                <Col span={4} />
                            </Row>
                        </Col>
                    </Row>
                    <Row className='row-billing-body-container bg-white'>
                        <Col span={1} />
                        <Col span={22}>
                            <Row className='mg-b-10'>
                                <Col span={24} className='col-billing-info'>
                                    <Text className='txt-billing-info'>Click to view detail / zoom in</Text>
                                </Col>
                            </Row>
                            <Row className='mg-b-10'>
                                <Col span={24} className='col-billing-image'>
                                    <Carousel dotPosition={'top'} className='carousel-billing'>
                                        <InnerImageZoom
                                            src={require('../../assets/image/Billing/BillingTest.png')}
                                            alt='BillingTest'
                                            fadeDuration={100}
                                        />
                                        <InnerImageZoom
                                            src={require('../../assets/image/Billing/BillingTest2.png')}
                                            alt='BillingTest2'
                                            fadeDuration={100}
                                        />
                                    </Carousel>
                                </Col>
                            </Row>
                        </Col>
                        <Col span={1} />
                    </Row>

                    <FooterMenu history={history} />
                </Content>
            </Layout>
        )
    }
}

export default withTranslation()(BillingPage)